
import React, { FunctionComponent, useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Grid,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import { getDocumentThumb, getFileType, Tenant } from '@ivymobi/orbit-core';
import { getAllCatalogsAction, getArticles, getCatlogsAction } from '@ivymobi/orbit-core/business/productCenter';
import { DeviceType, WebSiteContext, TenantContext, InnerUserContext, UserContext } from '../orbit-context';
import _ from 'lodash';
import PreviewDialog from '../documents/preview';
import { userShareEvent } from '@ivymobi/orbit-core/business/share';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  appcasePages: {
    display:'flex',
    flexDirection:'column',
    width:'100%',
    flexGrow:1,
    margin: '0 auto',
    "@media (min-width: 768px)": {
      marginTop: '12px',
    }, 
    //  "@media (max-width: 768px)": {
    //   marginTop: '0px',
    //  },
  
    // minWidth: '1200px',
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)  
  }
}));

const queryParse = (query)=>{
  query = query.substring(query.indexOf('?')+1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0,item.indexOf('='));
    let value= decodeURIComponent(item.substring(item.indexOf('=')+1));
    params[key]= value;
  });
  return params;
}

export const ArticalView = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const tenant = useContext(TenantContext);
  const deviceType = useContext(DeviceType);

  const { id } = useParams<any>() ?? {id: null};
  const params = queryParse(location.search);
  const innerUser = useContext(InnerUserContext);
  const {user, token} = useContext(UserContext);

  const [cInfo, setCInfo] = useState({cid: id, name: params.title});
  const [useLoading, setUseLoading] = useState(false);
  const [path, setPath] = useState([]);
  const [artData, setArtData] = useState([]);

  const isExistPath = (id) => {
    if (path && path.length > 0) {
      for (let i = 0; i < path.length; i++) {
        if (path[i].cid === id) {
          return i
        }
      }
    }
    return -1;
  };

  useEffect(() => {
    console.log('32312321312312123')
    setPath([])
    setCInfo({cid: id, name: params.title})
  }, [id]);
  
  useEffect(() => { 
      if (!tenant?.id) return; 


      setUseLoading(true);

      dispatch(getArticles({user: {token: null, user: null}, tenant: {id: tenant?.id}, id: id})).then((res) => {
        setPath([{cid: res.data[0].id, name: res.data[0].a_name}])
        if(res.data[0].a_type==1){
          dispatch(userShareEvent({user:{user:{id:innerUser?.userId??user?.id}}, share:{tenantId:tenant?.id,id:'11111111-1111-1111-1111-111111111111',memberId:innerUser?.memberId}, document:{id:id,type:'article'}, type:'view', detail:null}));

        }

        setArtData(res.data[0])
        setUseLoading(false);
      });
  }, [dispatch, id, tenant?.id]);

  // console.log("---------------------22222", path)

  // useEffect(() => {
  //   let ps = [];
  //   for(let i = 0; i < path.length - 1; i++) {
  //     ps.push({to:`/articles/${path[i].cid}`,name:path[i].name})
  //   }
  //   console.log('article path =====> ', path, params, ps)

  //   if (ps.length > 0 && (path[path.length-1]?.name || params.title)) {
  //     props.setParents(ps);
  //     props.setTitle(path[path.length-1]?.name??params.title)
  //   }
  // }, [path]);

  const rePath = (item) => {
    let _path = [];
    for (let i = 0; i < path.length; i++) {
      if (path[i].cid === item.cid) {     
        setPath(_path)
        return;
      }
      _path.push(path[i])
    }
    setPath(_path)
  }

  console.log("path ============", path);
  console.log('artDataartDataartDataartData', artData);

  return (
    <div style={{
      height:'calc(100% - 30px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      {deviceType === 'desktop' && <Breadcrumbs 
        style={{
          width: '80%',
          height: '40px',
          padding: '10px 0',
          display: 'flex',
          flexWrap: 'nowrap'
        }} separator=">" 
        maxItems={8}
      >
        <Link color='textPrimary' to={'/'} component={RouteLink}>首页</Link>

        {path.length > 0 && path[0].name !== '企业信息' && 
        <Link color='textPrimary' to={`/articles`} component={RouteLink}>企业信息</Link>}

        {path.length > 0 && path.map((item, idx) => {
          if (idx === path.length - 1) {
            return (<Typography key={idx} color="textPrimary">{ item.name }</Typography>)
          } else {
            return (<Link 
              key={idx} 
              color='textPrimary' 
              to={`/articles/${item.cid}?title=${item.name}`}
              component={RouteLink}
            >
              {item.name}
            </Link>)
          }
        })}
      </Breadcrumbs>}

      <Box 
        className={classes.appcasePages} 
        style={{
          width: deviceType === 'desktop' ? '80%' : '100%'
        }}
      >
        {artData?.a_type === 1 && <Box 
          style={{ 
            padding:'20px',
            background:'white',
            width:'100%',
            maxWidth:'1000px',
            // height:'100%',
            overflow:'auto'
          }} 
          dangerouslySetInnerHTML={{__html: artData?.info}}>
        </Box>}

        {artData.a_type === 0 && <Grid container spacing={3} className='cardGrid'>
          {artData.children.map((item, index) => {
            return (
              <Grid item xs={6} lg={3} key={index}>
                <Card 
                  onClick={() => {
                    console.log("==========================", item)
                    // setCInfo({cid: item.id, name: item.a_name})
                    history.push(`/articles/${item.id}?title=${item.a_name}`)
                  }} 
                  className='cardImage'
                >
                  <CardMedia component="img" className='cardMedia' height={140} image={item.thumbnail} />
                  <CardContent className='cardContent'>
                    <Typography>{item.a_name}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>}
      </Box>
    </div>
  );
};

export default function ArticalViewContainer (props: any) {
  // const dispatch = useDispatch();
  return (
    <ArticalView {...props}/>
  );
}